.checkbox {
  padding: 16px 13px;
  border-radius: 6px;
  width: 100%;

  @media screen and (min-width: 768px) {
    min-height: 130px;
  }

  &:not(:last-of-type) {
    margin-bottom: 4px;
  }
}

.checkboxDisabled {
  opacity: 0.3;
}

.option {
  margin-bottom: 13px;
  display: flex;
  align-items: center;
}

.optionTitle {
  margin-left: 5px;
  font-weight: 450;
  line-height: 1;
}

.optionDescription {
  color: var(--color-white);
  opacity: 0.6;
  font-size: 1.6rem;
  line-height: 2rem;
}
